module.exports = __webpack_public_path__ + "static/media/no_image.08441b70.png";